import { useState } from "react";
import {
  MiBox,
  MiBuildPageHeader,
  MiIcon,
  MiList,
  MiMenu,
} from "@miplatform/components";
import { ACCOUNT_TYPE, BUTTON_LABELS, PAGINATION } from "@miplatform/constants";
import { useDebounce, useRouter } from "@miplatform/hooks";
import { AccountType, IAccountListResponse } from "@miplatform/types";
import { mdiPencilOutline, mdiViewCompactOutline } from "@mdi/js";
import { Box, useTheme } from "@mui/material";
import { useAccounts } from "../../../../hooks/useAccount/useAccounts";
import { SectionInfo } from "../../components/SectionInfo/SectionInfo";

export function Customers() {
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search);

  const theme = useTheme();
  const { navigate } = useRouter();
  const { isLoading, accounts, getAccounts } = useAccounts({
    accountTypes: [ACCOUNT_TYPE.BUILDER] as AccountType[],
  });

  const sections = [
    {
      fieldset: [
        {
          renderValue: (data: IAccountListResponse) => (
            <SectionInfo data={data} />
          ),
        },
        {
          label: "Pricing Level",
          field: "pricingLevel",
          renderValue: (data: IAccountListResponse) =>
            data.priceLevelName ?? "--", // TODO: added in feature 40115
        },
        {
          label: "Draws",
          field: "draws",
          renderValue: () => "--", // TODO: added in feature 40119
        },
        {
          label: "Floors",
          field: "floors",
          renderValue: () => "--", // TODO: added in feature 40117
        },
      ],
    },
  ];

  const handleNavigate = (item: IAccountListResponse) => {
    if (item.id) {
      navigate(`/estimating/pricing/customers/${item.id}`);
    }
  };

  const renderItemActions = (item: IAccountListResponse) => (
    <Box onClick={(e) => e.stopPropagation()}>
      <MiMenu
        data={[
          {
            label: BUTTON_LABELS.EDIT,
            icon: mdiPencilOutline,
            action: () => handleNavigate(item),
          },
        ]}
      />
    </Box>
  );

  return (
    <>
      <MiBuildPageHeader
        title="Customers"
        loading={isLoading}
        search={search}
        onHandleSearch={(e: React.ChangeEvent<HTMLInputElement>) =>
          setSearch(e.target.value)
        }
        titleIcon={
          <MiIcon
            path={mdiViewCompactOutline}
            color={theme.palette.primary.main}
          />
        }
        actionContainerStyle={{
          flexWrap: "nowrap",
        }}
      />
      <MiBox>
        <MiList
          viewType="card"
          data={accounts}
          loading={isLoading}
          dataProvider={getAccounts}
          search={debouncedSearch}
          cardProps={{
            sections,
            renderItemActions,
            onClick: handleNavigate,
          }}
          groupedMode
          groupedCriteria={(customer: IAccountListResponse) =>
            `Price Level: ${customer.priceLevelName ?? "Undefined"}`
          }
          pinGroupKeyToTop="Price Level: Undefined"
          paginationMode={PAGINATION.SERVER}
          emptyListProps={{
            text: "No Customers found",
          }}
          data-testid="customers-list"
        />
      </MiBox>
    </>
  );
}
